import { actions } from './actions'

const initialState = {
  lotesImpresion: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function lotesImpresionReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOTES_IMPRESION_LOAD_REQUESTED:
      return { ...state, lotesImpresion: { ...state.lotesImpresion, loading: true } }
    case actions.LOTES_IMPRESION_LOAD_SUCCEEDED:
      return {
        ...state,
        lotesImpresion: { ...state.lotesImpresion, data: action.payload, loading: false },
      }
    case actions.LOTES_IMPRESION_LOAD_FAILED:
      return {
        ...state,
        lotesImpresion: { ...state.lotesImpresion, loading: false, error: action.error },
      }
    default:
      return state
  }
}
